const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStreetLamp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1743_2494",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 46,
    height: 50
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2644 0H2.5V50H47.2644V0Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1743_2494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.7956 7.22792V5.1903C43.7956 2.33857 41.4844 0.0273438 38.6326 0.0273438H11.0969C8.24582 0.0273438 5.93391 2.33857 5.93391 5.1903V7.22792C3.87545 7.9506 2.49598 9.89276 2.49194 12.0742C2.49194 14.926 4.80317 17.2372 7.6549 17.2372C10.506 17.2372 12.8179 14.926 12.8179 12.0742C12.8138 9.89276 11.4343 7.9506 9.37588 7.22792V5.1903C9.37588 4.23972 10.1463 3.46931 11.0969 3.46931H23.1438V32.7261H22.4258C21.4745 32.7287 20.563 33.1086 19.892 33.7835C19.2211 34.4578 18.8467 35.3714 18.8494 36.3226L18.1025 46.4939H12.8179C11.8969 46.5349 11.1722 47.2939 11.1722 48.2149C11.1722 49.1366 11.8975 49.8949 12.8179 49.9359H38.6326C39.5832 49.9359 40.3536 49.1655 40.3536 48.2149C40.3536 47.2643 39.5832 46.4939 38.6326 46.4939H31.6277L30.8761 36.1976C30.8795 34.3388 29.2822 32.7261 27.303 32.7261H26.5857V3.46931H38.6326C39.5832 3.46931 40.3536 4.23972 40.3536 5.1903V7.22792C38.2952 7.9506 36.9157 9.89276 36.9116 12.0742C36.9116 14.926 39.2229 17.2372 42.0746 17.2372C44.9257 17.2372 47.2376 14.926 47.2376 12.0742C47.2335 9.89276 45.854 7.9506 43.7956 7.22792ZM7.6549 13.7952C6.70432 13.7952 5.93391 13.0248 5.93391 12.0742C5.93391 11.1237 6.70432 10.3533 7.6549 10.3533C8.60547 10.3533 9.37588 11.1237 9.37588 12.0742C9.37588 13.0248 8.60547 13.7952 7.6549 13.7952ZM27.4375 36.3226L28.1776 46.4939H21.5539L22.2887 36.4484C22.292 36.2312 22.3559 36.168 22.4265 36.168H27.3024C27.3736 36.168 27.4375 36.2319 27.4375 36.3226ZM42.0746 13.7952C41.124 13.7952 40.3536 13.0248 40.3536 12.0742C40.3536 11.1237 41.124 10.3533 42.0746 10.3533C43.0252 10.3533 43.7956 11.1237 43.7956 12.0742C43.7956 13.0248 43.0252 13.7952 42.0746 13.7952Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStreetLamp);
export default __webpack_public_path__ + "static/media/icon-street-lamp.c1794b315955ad6be472b6099f4d1d8d.svg";
export { ForwardRef as ReactComponent };